// LoginForm.js
import React from 'react';
import { Link } from 'react-router-dom';

import {  Box, Text } from '@radix-ui/themes';

import { createPopup } from '../../../js/popup'

function getScreenSizeForTextSize() {
  if(window.innerWidth < 768) {
    return true
  }
  return false
}

const LoginForm = () => {

    const handleSubmit = async (e) => {
      e.preventDefault();
      const formData = new FormData(e.target);
    
      const data = {
        email: formData.get("email"),
        password: formData.get("password"),
      };
    
      const res = await fetch("https://kissaten.koffy.finance/user/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    
      const body = await res.json();
      if(body.success === "ok") {
        document.cookie = `token=${body.cookie}; path=/; max-age=86400; SameSite=None; Secure`;
        setTimeout(() => {
          window.location.href = "/app";
        }, 1000);
        
      } else {
        createPopup(body.error_description)
      }
      

      

    };


  return (
        <div className="w-full h-100">
            <form onSubmit={handleSubmit}>
                <div>
                    <img className="h-12 mb-5" src='/imgs/koffy_logo.png' alt='koffy logo' />
                    <h1 className="text-xl md:text-2xl font-pt-serif font-bold leading-tight mt-12"><span
                            className="bg-underline1 bg-left-bottom bg-no-repeat pb-3 bg-100%">
                            Se connecter à Koffy </span></h1>
                

                    <div className="mt-4">
                        <label className="font-montserrat block text-gray-700">Adresse e-mail</label>
                        <input id="email" name="email" type="email" placeholder="Adresse e-mail"
                            className="w-full px-4 py-3 rounded-lg bg-gray-200 mt-2 border focus:border-black focus:bg-white focus:outline-none" required />
                    </div>
                    <div  className="mt-4">
                        <label className="font-montserrat block text-gray-700">Mot de passe</label>
                        <input id="password" name="password" type="password" placeholder="Mot de passe" minLength="6" className="w-full px-4 py-3 rounded-lg bg-gray-200 mt-2 border focus:border-black
                    focus:bg-white focus:outline-none" required />
                    </div>
                    <div>
                        <button type="submit" className="w-full block bg-black hover:bg-white hover:bg-gray-200 hover:text-black text-white font-semibold rounded-lg
                    px-4 py-3 mt-6">Connexion</button>
                    </div>
                    
                    {
                      (!getScreenSizeForTextSize()) ? (
                        <div className="text-right mt-2">
                          <Link to="/forgot" className="text-sm font-semibold text-gray-700 hover:text-yellow-700 focus:text-yellow-700">
                          Mot de passe oublié ?
                          </Link>
                      </div>
                      ) : (<></>)
                    }

                    <hr className="my-6 border-gray-300 w-full" />

                    {
                      (getScreenSizeForTextSize()) ? (
                        <Box style={{width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: "15px"}}>
                          <Box style={{ backgroundColor: '#ebd0a3', minHeight: "35px", width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '5px'}}>
                              <Text style={{width: '100%', textAlign: 'center'}}>
                                  <Link href="#" style={{color: "black"}}>
                                    Please first register and subscribe on our website via a computer or a tablet. Registration is not available on mobile
                                  </Link>
                              </Text>
                          </Box>
                      </Box>

                      ) : (<></>)
                    }

{
                      (getScreenSizeForTextSize()) ? (
                        <Box style={{width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: "15px"}}>
                          <Box style={{ backgroundColor: '#ebd0a3', minHeight: "35px", width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '5px'}}>
                              <Text style={{width: '100%', textAlign: 'center'}}>
                                  <Link href="#" style={{color: "black"}}>
                                  Veuillez d'abord vous inscrire et vous abonner sur notre site web via un ordinateur ou une tablette. L'inscription n'est pas disponible sur mobile
                                  </Link>
                              </Text>
                          </Box>
                      </Box>

                      ) : (<></>)
                    }

                    {
                      (!getScreenSizeForTextSize()) ? (
                        <p className="mt-8 font-montserrat">
                          <Link to="/register" className="text-black font-montserrat hover:text-black font-semibold">Vous n’avez pas
                          encore de compte ?</Link>
                      </p>
                      ) : (<></>)
                    }
                    <div></div>


                    {
                      // APP BE LIKE
                      (!getScreenSizeForTextSize()) ? (
                        <p className="mt-4 font-montserrat">
                          <a href='/' className="text-blue-600 hover:text-blue-700 font-semibold"> Revenir à l'accueil</a>
                        </p>
                      ) : (<></>)
                    }
                    
                </div>
            </form>
        </div>
  );
};

export default LoginForm;
